import Vue from 'vue'
import VueButtonSpinner from '@/components/loadingButton.vue';
Vue.component('button-spinner', VueButtonSpinner)